import { MODA_ARTICOLI_COLUMN_METADATA } from "./modaArticoliColumnMetadata";

export const STATO_ARTICOLI_ANAGRAFICA_IDS = ["codiceVS", "nome", "brand", "stagioneAcquisto", "pubblicato"];
export const STATO_ARTICOLI_COLUMN_METADATA = [
  ...STATO_ARTICOLI_ANAGRAFICA_IDS.map((id) => MODA_ARTICOLI_COLUMN_METADATA.find((meta) => meta.id === id)),
  { id: "backfillVigBot", header: "Backfill VIG → BOT", label: "Backfill VIG → BOT" },
  { id: "backfillBotVig", header: "Backfill BOT → VIG", label: "Backfill BOT → VIG" },
  { id: "backfillRecuperoBot", header: "Recupero BOT", label: "Backfill recupero BOT" },
  { id: "backfillImmaginiBot", header: "Backfill immagini BOT", label: "Backfill immagini BOT" },
  { id: "traduzioniVig", header: "VIG Traduzioni", label: "VIG Traduzioni pronte in Domino" },
  { id: "traduzioniBot", header: "BOT Traduzioni", label: "BOT Traduzioni pronte in Domino" },
  ...["Vig", "Bot"].flatMap((site) => [
    { id: `pubblicato${site}`, header: `${site.toUpperCase()} Pubblicato`, label: `${site.toUpperCase()} Pubblicato` },
    { id: `testi${site}`, header: `${site.toUpperCase()} Testi`, label: `${site.toUpperCase()} Testi online in cache` },
    { id: `immagini${site}`, header: `${site.toUpperCase()} Immagini`, label: `${site.toUpperCase()} Immagini` },
    { id: `visibilita${site}`, header: `${site.toUpperCase()} Visibilità`, label: `${site.toUpperCase()} Visibilità` },
  ]),
];
export const STATO_ARTICOLI_COLUMN_IDS = STATO_ARTICOLI_COLUMN_METADATA.map(({ id }) => id);
export const STATO_ARTICOLI_LOCKED_COLUMN_IDS = ["codiceVS"];
